(ns practitest.frontend.common.bugtrackers
  (:require [clojure.string :as str]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]
            [practitest.frontend.subs :as subs]))

(defn jira? [bugtracker]
  (when (string? bugtracker)
    (str/includes? (str/lower-case bugtracker) "jira")))

(defn clickup? [bugtracker]
  (when (string? bugtracker)
    (str/includes? (str/lower-case bugtracker) "clickup")))

(defn azure? [bugtracker]
  (when (string? bugtracker)
    (str/includes? (str/lower-case bugtracker) "azure")))

(defn pivotal? [bugtracker]
  (when (string? bugtracker)
    (str/includes? (str/lower-case bugtracker) "pivotal")))

(defn youtrack? [bugtracker]
  (when (string? bugtracker)
    (str/includes? (str/lower-case bugtracker) "youtrack")))

(defn service-now? [bugtracker]
  (when (string? bugtracker)
    (str/includes? (str/lower-case bugtracker) "servicenow")))

;; Mirrors IntegrationSetting::OneWay::ONE_WAY_TRACKERS in practitest-app. One-way integrations
;; have no API-based create/fetch-fields support - they only redirect out to the tracker's own
;; "create issue" page (see step_runs#integration_redirector).
(def one-way-trackers
  #{"bugzilla" "jiraoneway" "github" "gitlab" "fogbugz" "assembla" "trac" "lighthouse" "mantis"
    "youtrackoneway" "custom"})

(defn one-way? [bugtracker]
  (when (string? bugtracker)
    (contains? one-way-trackers (str/lower-case bugtracker))))

(defn get-logo-path
  [bugtracker]
  (when-not (reagent/current-component)
    (js/console.warn "Must be called in reactive context (e.g. render function)"))
  (when (string? bugtracker)
    (let [options @(re-frame/subscribe [::subs/options])]
      (cond
        (jira? bugtracker)
        (:jira-logo-path options)

        (clickup? bugtracker)
        (:clickup-logo-path options)

        (azure? bugtracker)
        (:azure-logo-path options)
        :else
        (do
          (js/console.warn "Invalid bugtracker type provided" bugtracker)
          ;; fallback to Jira for now
          (:jira-logo-path options))))))

(defn get-label
  [bugtracker]
  (when (string? bugtracker)
    (cond
      (jira? bugtracker)
      "Jira"

      (clickup? bugtracker)
      "ClickUp"

      (azure? bugtracker)
      "Azure"

      (pivotal? bugtracker)
      "Pivotal Tracker"

      (youtrack? bugtracker)
      "Youtrack"

      (service-now? bugtracker)
      "ServiceNow"

      :else
      (str "Unknown: " bugtracker))))

(defn get-unique-jira-projects
  "Extract unique Jira projects from jira_options (which contains project+issue_type combinations)"
  [jira-options]
  (->> jira-options
       (group-by :p_id)
       (map (fn [[p_id projects]]
              (first projects)))  ; Take first project entry for each unique p_id
       (map #(select-keys % [:p_id :jira_proj_name :jira_proj_key :entity_disabled]))))
